import ErrorBlock from "@/components/ErrorBlock";
import LoadingCard from "../../ProductCard/Loading";
import { SearchErrors } from "@/typings/ErrorStates";

const ErrorGrid = ({ error,handlePrompt = () => {},onSearchSubmit = () => {} }: { error: SearchErrors;handlePrompt?: (query: string) => void; onSearchSubmit?: (query: boolean) => void; }) => {
  const MAX_SKELETON_LENGTH = 12;

  return (
    <>
      <ErrorBlock  error={error} handlePrompt={handlePrompt} onSearchSubmit={onSearchSubmit} />
      <div className="hidden relative mt-8 md:flex justify-center">
        <div className="max-w-[1440px] grid md:grid-cols-3 xl:grid-cols-4 gap-4 mt-[24px] mx-[8px] sm:mx-[24px] lg:mx-[40px] xxl:mx-[228px]">
          {Array.from({ length: MAX_SKELETON_LENGTH })?.map(
            (_skeleton, index) => {
              return <LoadingCard key={index + 1} noAnimation />;
            }
          )}
        </div>
      </div>
    </>
  );
};

export default ErrorGrid;
